import {
  commonGstURL,
  commonAggregateGstURL
} from 'src/constantsMessage/index';
import helperAxios from 'src/utils/helperAxios';
import { SET_ALERT } from 'src/actions/alertAction';

export const LOADER = '@gstrAnalysis/loader';
export const EMPTY_DATA = '@gstrAnalysis/empty-data';
export const GET_GSTR_OVERVIEW = '@gstrAnalysis/get-overview';
export const GET_GSTR_OVERVIEW_ERROR = '@gstrAnalysis/get-overview-error';
export const GET_GSTR_OVERVIEW_EMPTY = '@gstrAnalysis/get-overview-empty';
export const GET_AGGREGATE_GSTR_OVERVIEW = '@gstrAnalysis/get-overview';
export const GET_AGGREGATE_GSTR_OVERVIEW_ERROR =
  '@gstrAnalysis/get-overview-error';
export const GET_AGGREGATE_GSTR_OVERVIEW_EMPTY =
  '@gstrAnalysis/get-overview-empty';
export const GET_SALES_SUMMARY = '@gstrAnalysis/get-salessummary';
export const GET_SALES_SUMMARY_ERROR = '@gstrAnalysis/get-salessummary-error';
export const GET_SALES_SUMMARY_EMPTY = '@gstrAnalysis/get-salessummary-empty';

export const GET_AGGREGATE_SALES_SUMMARY = '@gstrAnalysis/get-salessummary';
export const GET_AGGREGATE_SALES_SUMMARY_ERROR =
  '@gstrAnalysis/get-salessummary-error';
export const GET_AGGREGATE_SALES_SUMMARY_EMPTY =
  '@gstrAnalysis/get-salessummary-empty';
export const SET_SALES_SUMMARY_PERSIST = '@gstrAnalysis/set-salessummary';
export const GET_SALES_STATE = '@gstrAnalysis/get-salesstate';
export const GET_SALES_STATE_ERROR = '@gstrAnalysis/get-salesstate-error';
export const GET_SALES_STATE_EMPTY = '@gstrAnalysis/get-salesstate-empty';

export const GET_AGGREGATE_SALES_STATE = '@gstrAnalysis/get-salesstate';
export const GET_AGGREGATE_SALES_STATE_ERROR =
  '@gstrAnalysis/get-salesstate-error';
export const GET_AGGREGATE_SALES_STATE_EMPTY =
  '@gstrAnalysis/get-salesstate-empty';

export const SET_SALES_STATE_PERSIST = '@gstrAnalysis/set-salesstate';
export const GET_SALES_CATEGORY = '@gstrAnalysis/get-salescategory';
export const GET_SALES_CATEGORY_ERROR = '@gstrAnalysis/get-salescategory-error';
export const GET_SALES_CATEGORY_EMPTY = '@gstrAnalysis/get-salescategory-empty';
export const GET_AGGREGATE_SALES_CATEGORY = '@gstrAnalysis/get-salescategory';
export const GET_AGGREGATE_SALES_CATEGORY_ERROR =
  '@gstrAnalysis/get-salescategory-error';
export const GET_AGGREGATE_SALES_CATEGORY_EMPTY =
  '@gstrAnalysis/get-salescategory-empty';
export const SET_SALES_CATEGORY_PERSIST = '@gstrAnalysis/set-salescategory';
export const GET_SALES_CUSTOMER = '@gstrAnalysis/get-salescustomer';
export const GET_SALES_CUSTOMER_ERROR = '@gstrAnalysis/get-salescustomer-error';
export const GET_SALES_CUSTOMER_EMPTY = '@gstrAnalysis/get-salescustomer-empty';
export const GET_AGGREGATE_SALES_CUSTOMER = '@gstrAnalysis/get-salescustomer';
export const GET_AGGREGATE_SALES_CUSTOMER_ERROR =
  '@gstrAnalysis/get-salescustomer-error';
export const GET_AGGREGATE_SALES_CUSTOMER_EMPTY =
  '@gstrAnalysis/get-salescustomer-empty';
export const SET_SALES_CUSTOMER_PERSIST = '@gstrAnalysis/set-salescustomer';
export const GET_SALES_HSNSUMMARY = '@gstrAnalysis/get-saleshsnsummary';
export const GET_SALES_HSNSUMMARY_ERROR =
  '@gstrAnalysis/get-saleshsnsummary-error';
export const GET_SALES_HSNSUMMARY_EMPTY =
  '@gstrAnalysis/get-saleshsnsummary-empty';

export const GET_AGGREGATE_SALES_HSNSUMMARY =
  '@gstrAnalysis/get-saleshsnsummary';
export const GET_AGGREGATE_SALES_HSNSUMMARY_ERROR =
  '@gstrAnalysis/get-saleshsnsummary-error';
export const GET_AGGREGATE_SALES_HSNSUMMARY_EMPTY =
  '@gstrAnalysis/get-saleshsnsummary-empty';
export const SET_SALES_HSNSUMMARY_PERSIST = '@gstrAnalysis/set-saleshsnsummary';
export const GET_SALES_INTRAORGANIZATION =
  '@gstrAnalysis/get-intraorganizationsales';
export const GET_SALES_INTRAORGANIZATION_ERROR =
  '@gstrAnalysis/get-intraorganizationsales-error';
export const GET_SALES_INTRAORGANIZATION_EMPTY =
  '@gstrAnalysis/get-intraorganizationsales-empty';

export const GET_AGGREGATE_SALES_INTRAORGANIZATION =
  '@gstrAnalysis/get-intraorganizationsales';
export const GET_AGGREGATE_SALES_INTRAORGANIZATION_ERROR =
  '@gstrAnalysis/get-intraorganizationsales-error';
export const GET_AGGREGATE_SALES_INTRAORGANIZATION_EMPTY =
  '@gstrAnalysis/get-intraorganizationsales-empty';

export const SET_SALES_INTRAORGANIZATION_PERSIST =
  '@gstrAnalysis/set-intraorganizationsales';
export const GET_PURCHASES_SUMMARY = '@gstrAnalysis/get-purchasessummary';
export const GET_PURCHASES_SUMMARY_ERROR =
  '@gstrAnalysis/get-purchasessummary-error';
export const GET_PURCHASES_SUMMARY_EMPTY =
  '@gstrAnalysis/get-purchasessummary-empty';

export const GET_AGGREGATE_PURCHASES_SUMMARY =
  '@gstrAnalysis/get-purchasessummary';
export const GET_AGGREGATE_PURCHASES_SUMMARY_ERROR =
  '@gstrAnalysis/get-purchasessummary-error';
export const GET_AGGREGATE_PURCHASES_SUMMARY_EMPTY =
  '@gstrAnalysis/get-purchasessummary-empty';

export const SET_PURCHASES_SUMMARY_PERSIST =
  '@gstrAnalysis/set-purchasessummary';
export const GET_PURCHASES_STATE = '@gstrAnalysis/get-purchasesstate';
export const GET_PURCHASES_STATE_ERROR =
  '@gstrAnalysis/get-purchasesstate-error';
export const GET_PURCHASES_STATE_EMPTY =
  '@gstrAnalysis/get-purchasesstate-empty';

export const GET_AGGREGATE_PURCHASES_STATE = '@gstrAnalysis/get-purchasesstate';
export const GET_AGGREGATE_PURCHASES_STATE_ERROR =
  '@gstrAnalysis/get-purchasesstate-error';
export const GET_AGGREGATE_PURCHASES_STATE_EMPTY =
  '@gstrAnalysis/get-purchasesstate-empty';

export const SET_PURCHASES_STATE_PERSIST = '@gstrAnalysis/set-purchasesstate';
export const GET_PURCHASES_CATEGORY = '@gstrAnalysis/get-purchasescategory';
export const GET_PURCHASES_CATEGORY_ERROR =
  '@gstrAnalysis/get-purchasescategory-error';
export const GET_PURCHASES_CATEGORY_EMPTY =
  '@gstrAnalysis/get-purchasescategory-empty';

export const GET_AGGREGATE_PURCHASES_CATEGORY =
  '@gstrAnalysis/get-purchasescategory';
export const GET_AGGREGATE_PURCHASES_CATEGORY_ERROR =
  '@gstrAnalysis/get-purchasescategory-error';
export const GET_AGGREGATE_PURCHASES_CATEGORY_EMPTY =
  '@gstrAnalysis/get-purchasescategory-empty';

export const SET_PURCHASES_CATEGORY_PERSIST =
  '@gstrAnalysis/set-purchasescategory';
export const GET_PURCHASES_SUPPLIERS = '@gstrAnalysis/get-purchasessuppliers';
export const GET_PURCHASES_SUPPLIERS_ERROR =
  '@gstrAnalysis/get-purchasessuppliers-error';
export const GET_PURCHASES_SUPPLIERS_EMPTY =
  '@gstrAnalysis/get-purchasessuppliers-empty';

export const GET_AGGREGATE_PURCHASES_SUPPLIERS =
  '@gstrAnalysis/get-purchasessuppliers';
export const GET_AGGREGATE_PURCHASES_SUPPLIERS_ERROR =
  '@gstrAnalysis/get-purchasessuppliers-error';
export const GET_AGGREGATE_PURCHASES_SUPPLIERS_EMPTY =
  '@gstrAnalysis/get-purchasessuppliers-empty';

export const SET_PURCHASES_SUPPLIERS_PERSIST =
  '@gstrAnalysis/set-purchasessuppliers';
export const GET_PURCHASES_INTRAORGANIZATION =
  '@gstrAnalysis/get-intraorganizationpurchases';
export const GET_PURCHASES_INTRAORGANIZATION_ERROR =
  '@gstrAnalysis/get-intraorganizationpurchases-error';
export const GET_PURCHASES_INTRAORGANIZATION_EMPTY =
  '@gstrAnalysis/get-intraorganizationpurchases-empty';

export const GET_AGGREGATE_PURCHASES_INTRAORGANIZATION =
  '@gstrAnalysis/get-intraorganizationpurchases';
export const GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_ERROR =
  '@gstrAnalysis/get-intraorganizationpurchases-error';
export const GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_EMPTY =
  '@gstrAnalysis/get-intraorganizationpurchases-empty';

export const SET_PURCHASES_INTRAORGANIZATION_PERSIST =
  '@gstrAnalysis/set-intraorganizationpurchases';
export const GET_CYCLICTXN = '@gstrAnalysis/get-cyclictxn';
export const GET_CYCLICTXN_ERROR = '@gstrAnalysis/get-cyclictxn-error';
export const GET_CYCLICTXN_EMPTY = '@gstrAnalysis/get-cyclictxn-empty';

export const GET_AGGREGATE_CYCLICTXN = '@gstrAnalysis/get-cyclictxn';
export const GET_AGGREGATE_CYCLICTXN_ERROR =
  '@gstrAnalysis/get-cyclictxn-error';
export const GET_AGGREGATE_CYCLICTXN_EMPTY =
  '@gstrAnalysis/get-cyclictxn-empty';

export const SET_CYCLICTXN_PERSIST = '@gstrAnalysis/set-cyclictxn';
export const GET_NOTES = '@gstrAnalysis/get-notes';
export const GET_NOTES_ERROR = '@gstrAnalysis/get-notes-error';
export const GET_NOTES_EMPTY = '@gstrAnalysis/get-notes-empty';

export const GET_AGGREGATE_NOTES = '@gstrAnalysis/get-notes';
export const GET_AGGREGATE_NOTES_ERROR = '@gstrAnalysis/get-notes-error';
export const GET_AGGREGATE_NOTES_EMPTY = '@gstrAnalysis/get-notes-empty';
export const SET_NOTES_PERSIST = '@gstrAnalysis/set-notes';
export const GET_TAXLIABILITY = '@gstrAnalysis/get-taxliability';
export const GET_TAXLIABILITY_ERROR = '@gstrAnalysis/get-taxliability-error';
export const GET_TAXLIABILITY_EMPTY = '@gstrAnalysis/get-taxliability-empty';

export const GET_AGGREGATE_TAXLIABILITY = '@gstrAnalysis/get-taxliability';
export const GET_AGGREGATE_TAXLIABILITY_ERROR =
  '@gstrAnalysis/get-taxliability-error';
export const GET_AGGREGATE_TAXLIABILITY_EMPTY =
  '@gstrAnalysis/get-taxliability-empty';

export const SET_TAXLIABILITY_PERSIST = '@gstrAnalysis/set-taxliability';
export const GET_INPUT_TAXCREDIT = '@gstrAnalysis/get-inputtax';
export const GET_INPUT_TAXCREDIT_ERROR = '@gstrAnalysis/get-inputtax-error';
export const GET_INPUT_TAXCREDIT_EMPTY = '@gstrAnalysis/get-inputtax-empty';

export const GET_AGGREGATE_INPUT_TAXCREDIT = '@gstrAnalysis/get-inputtax';
export const GET_AGGREGATE_INPUT_TAXCREDIT_ERROR =
  '@gstrAnalysis/get-inputtax-error';
export const GET_AGGREGATE_INPUT_TAXCREDIT_EMPTY =
  '@gstrAnalysis/get-inputtax-empty';

export const SET_INPUT_TAXCREDIT_PERSIST = '@gstrAnalysis/set-inputtax';
export const GET_FILINGSTATUS = '@gstrAnalysis/get-filingstatus';
export const GET_FILINGSTATUS_ERROR = '@gstrAnalysis/get-filingstatus-error';
export const GET_FILINGSTATUS_EMPTY = '@gstrAnalysis/get-filingstatus-empty';
export const SET_FILINGSTATUS_PERSIST = '@gstrAnalysis/set-filingstatus';
export const SET_SUBTABS_PERSIST = '@gstrAnalysis/set-subtabs';
export const GET_SALES_CUSTOMER_BY_MONTH =
  '@gstrAnalysis/get-salescustomer-by-month';
export const GET_SALES_CUSTOMER_BY_MONTH_ERROR =
  '@gstrAnalysis/get-salescustomer-by-month-error';
export const GET_SALES_CUSTOMER_BY_MONTH_EMPTY =
  '@gstrAnalysis/get-salescustomer-by-month-empty';
export const GET_PURCHASES_SUPPLIERS_BY_MONTH =
  '@gstrAnalysis/get-purchasessuppliers-by-month';
export const GET_PURCHASES_SUPPLIERS_BY_MONTH_ERROR =
  '@gstrAnalysis/get-purchasessuppliers-by-month-error';
export const GET_PURCHASES_SUPPLIERS_BY_MONTH_EMPTY =
  '@gstrAnalysis/get-purchasessuppliers-by-month-empty';

export function emptyGstrAnalysis() {
  return dispatch => {
    dispatch({
      type: EMPTY_DATA,
      payload: null
    });
  };
}

export function getGstrOverview(gstId) {
  const url = `${commonGstURL}/overview?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_GSTR_OVERVIEW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_GSTR_OVERVIEW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyGstrOverview() {
  return dispatch => {
    dispatch({
      type: GET_GSTR_OVERVIEW_EMPTY,
      payload: null
    });
  };
}

export function getAggregateGstrOverview(reportId) {
  const url = `${commonAggregateGstURL}/overview?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_GSTR_OVERVIEW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_GSTR_OVERVIEW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateGstrOverview() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_GSTR_OVERVIEW_EMPTY,
      payload: null
    });
  };
}

export function getSalesSummary(gstId) {
  const url = `${commonGstURL}/gstrSalesSummary?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALES_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALES_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesSummary() {
  return dispatch => {
    dispatch({
      type: GET_SALES_SUMMARY_EMPTY,
      payload: null
    });
  };
}

export function getAggregateSalesSummary(reportId) {
  const url = `${commonAggregateGstURL}/gstrSalesSummary?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_SALES_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_SALES_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateSalesSummary() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_SALES_SUMMARY_EMPTY,
      payload: null
    });
  };
}

export function setSalesSummaryPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SALES_SUMMARY_PERSIST,
      payload: data
    });
  };
}

export function getSalesState(gstId) {
  const url = `${commonGstURL}/salesState?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALES_STATE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALES_STATE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesState() {
  return dispatch => {
    dispatch({
      type: GET_SALES_STATE_EMPTY,
      payload: null
    });
  };
}

export function getAggregateSalesState(reportId) {
  const url = `${commonAggregateGstURL}/salesState?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_SALES_STATE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_SALES_STATE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateSalesState() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_SALES_STATE_EMPTY,
      payload: null
    });
  };
}

export function setSalesStatePersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SALES_STATE_PERSIST,
      payload: data
    });
  };
}

export function getSalesCategory(gstId) {
  const url = `${commonGstURL}/salesCategory?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALES_CATEGORY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALES_CATEGORY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesCategory() {
  return dispatch => {
    dispatch({
      type: GET_SALES_CATEGORY_EMPTY,
      payload: null
    });
  };
}

export function getAggregateSalesCategory(reportId) {
  const url = `${commonAggregateGstURL}/salesCategory?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_SALES_CATEGORY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_SALES_CATEGORY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregarteSalesCategory() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_SALES_CATEGORY_EMPTY,
      payload: null
    });
  };
}

export function setSalesCategoryPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SALES_CATEGORY_PERSIST,
      payload: data
    });
  };
}

export function getSalesCustomer(gstId) {
  const url = `${commonGstURL}/salesCustomers?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALES_CUSTOMER,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALES_CUSTOMER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesCustomer() {
  return dispatch => {
    dispatch({
      type: GET_SALES_CUSTOMER_EMPTY,
      payload: null
    });
  };
}

export function getAggregateSalesCustomer(reportId) {
  const url = `${commonAggregateGstURL}/salesCustomers?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_SALES_CUSTOMER,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_SALES_CUSTOMER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateSalesCustomer() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_SALES_CUSTOMER_EMPTY,
      payload: null
    });
  };
}

export function setSalesCustomerPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SALES_CUSTOMER_PERSIST,
      payload: data
    });
  };
}

export function getSalesHsnSummary(gstId) {
  const url = `${commonGstURL}/salesHsnSummary?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALES_HSNSUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALES_HSNSUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesHsnSummary() {
  return dispatch => {
    dispatch({
      type: GET_SALES_HSNSUMMARY_EMPTY,
      payload: null
    });
  };
}

export function getAggregateSalesHsnSummary(reportId) {
  const url = `${commonAggregateGstURL}/salesHsnSummary?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_SALES_HSNSUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_SALES_HSNSUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateSalesHsnSummary() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_SALES_HSNSUMMARY_EMPTY,
      payload: null
    });
  };
}

export function setSalesHsnSummaryPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SALES_HSNSUMMARY_PERSIST,
      payload: data
    });
  };
}

export function getSalesIntraOrganization(gstId) {
  const url = `${commonGstURL}/salesIntraOrganization?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALES_INTRAORGANIZATION,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALES_INTRAORGANIZATION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesIntraOrganization() {
  return dispatch => {
    dispatch({
      type: GET_SALES_INTRAORGANIZATION_EMPTY,
      payload: null
    });
  };
}

export function getAggregateSalesIntraOrganization(reportId) {
  const url = `${commonAggregateGstURL}/salesIntraOrganization?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_SALES_INTRAORGANIZATION,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_SALES_INTRAORGANIZATION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateSalesIntraOrganization() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_SALES_INTRAORGANIZATION_EMPTY,
      payload: null
    });
  };
}

export function setSalesIntraOrganizationPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SALES_INTRAORGANIZATION_PERSIST,
      payload: data
    });
  };
}

export function getPurchasesSummary(gstId) {
  const url = `${commonGstURL}/purchaseSummary?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_PURCHASES_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PURCHASES_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyPurchasesSummary() {
  return dispatch => {
    dispatch({
      type: GET_PURCHASES_SUMMARY_EMPTY,
      payload: null
    });
  };
}

export function getAggregatePurchasesSummary(reportId) {
  const url = `${commonAggregateGstURL}/purchaseSummary?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_PURCHASES_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_PURCHASES_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregatePurchasesSummary() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_PURCHASES_SUMMARY_EMPTY,
      payload: null
    });
  };
}

export function setPurchasesSummaryPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_PURCHASES_SUMMARY_PERSIST,
      payload: data
    });
  };
}

export function getPurchasesState(gstId) {
  const url = `${commonGstURL}/purchasesState?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_PURCHASES_STATE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PURCHASES_STATE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyPurchasesState() {
  return dispatch => {
    dispatch({
      type: GET_PURCHASES_STATE_EMPTY,
      payload: null
    });
  };
}

export function getAggregatePurchasesState(reportId) {
  const url = `${commonAggregateGstURL}/purchasesState?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_PURCHASES_STATE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_PURCHASES_STATE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregatePurchasesState() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_PURCHASES_STATE_EMPTY,
      payload: null
    });
  };
}

export function setPurchasesStatePersist(data) {
  return dispatch => {
    dispatch({
      type: SET_PURCHASES_STATE_PERSIST,
      payload: data
    });
  };
}

export function getPurchasesCategory(gstId) {
  const url = `${commonGstURL}/purchaseCategory?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_PURCHASES_CATEGORY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PURCHASES_CATEGORY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyPurchasesCategory() {
  return dispatch => {
    dispatch({
      type: GET_PURCHASES_CATEGORY_EMPTY,
      payload: null
    });
  };
}

export function getAggregatePurchasesCategory(reportId) {
  const url = `${commonAggregateGstURL}/purchaseCategory?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_PURCHASES_CATEGORY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_PURCHASES_CATEGORY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregatePurchasesCategory() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_PURCHASES_CATEGORY_EMPTY,
      payload: null
    });
  };
}

export function setPurchasesCategoryPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_PURCHASES_CATEGORY_PERSIST,
      payload: data
    });
  };
}

export function getPurchasesSuppliers(gstId) {
  const url = `${commonGstURL}/purchasesSuppliers?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_PURCHASES_SUPPLIERS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PURCHASES_SUPPLIERS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyPurchasesSuppliers() {
  return dispatch => {
    dispatch({
      type: GET_PURCHASES_SUPPLIERS_EMPTY,
      payload: null
    });
  };
}

export function getAggregatePurchasesSuppliers(reportId) {
  const url = `${commonAggregateGstURL}/purchasesSuppliers?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_PURCHASES_SUPPLIERS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_PURCHASES_SUPPLIERS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregatePurchasesSuppliers() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_PURCHASES_SUPPLIERS_EMPTY,
      payload: null
    });
  };
}

export function setPurchasesSuppliersPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_PURCHASES_SUPPLIERS_PERSIST,
      payload: data
    });
  };
}

export function getPurchasesIntraOrganization(gstId) {
  const url = `${commonGstURL}/purchaseIntraOrganization?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_PURCHASES_INTRAORGANIZATION,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PURCHASES_INTRAORGANIZATION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyPurchasesIntraOrganization() {
  return dispatch => {
    dispatch({
      type: GET_PURCHASES_INTRAORGANIZATION_EMPTY,
      payload: null
    });
  };
}

export function getAggregatePurchasesIntraOrganization(reportId) {
  const url = `${commonAggregateGstURL}/purchaseIntraOrganization?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_PURCHASES_INTRAORGANIZATION,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregatePurchasesIntraOrganization() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_EMPTY,
      payload: null
    });
  };
}

export function setPurchasesIntraOrganizationPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_PURCHASES_INTRAORGANIZATION_PERSIST,
      payload: data
    });
  };
}

export function getCyclicTxn(gstId) {
  const url = `${commonGstURL}/cyclicTxn?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CYCLICTXN,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CYCLICTXN_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyCyclicTxn() {
  return dispatch => {
    dispatch({
      type: GET_CYCLICTXN_EMPTY,
      payload: null
    });
  };
}

export function getAggregateCyclicTxn(reportId) {
  const url = `${commonAggregateGstURL}/cyclicTxn?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_CYCLICTXN,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_CYCLICTXN_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateCyclicTxn() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_CYCLICTXN_EMPTY,
      payload: null
    });
  };
}

export function setCyclicTxnPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_CYCLICTXN_PERSIST,
      payload: data
    });
  };
}

export function getNotes(gstId) {
  const url = `${commonGstURL}/creditDebitNotes?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_NOTES,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_NOTES_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyNotes() {
  return dispatch => {
    dispatch({
      type: GET_NOTES_EMPTY,
      payload: null
    });
  };
}

export function getAggregateNotes(reportId) {
  const url = `${commonAggregateGstURL}/creditDebitNotes?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_NOTES,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_NOTES_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateNotes() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_NOTES_EMPTY,
      payload: null
    });
  };
}

export function setNotesPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_NOTES_PERSIST,
      payload: data
    });
  };
}

export function getTaxLiability(gstId) {
  const url = `${commonGstURL}/taxLiability?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_TAXLIABILITY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_TAXLIABILITY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyTaxLiability() {
  return dispatch => {
    dispatch({
      type: GET_TAXLIABILITY_EMPTY,
      payload: null
    });
  };
}

export function getAggregateTaxLiability(reportId) {
  const url = `${commonAggregateGstURL}/taxLiability?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_TAXLIABILITY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_TAXLIABILITY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateTaxLiability() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_TAXLIABILITY_EMPTY,
      payload: null
    });
  };
}

export function setTaxLiabilityPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_TAXLIABILITY_PERSIST,
      payload: data
    });
  };
}

export function getInputTaxCredit(gstId) {
  const url = `${commonGstURL}/inputTaxCredit?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_INPUT_TAXCREDIT,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_INPUT_TAXCREDIT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyInputTaxCredit() {
  return dispatch => {
    dispatch({
      type: GET_INPUT_TAXCREDIT_EMPTY,
      payload: null
    });
  };
}

export function getAggregateInputTaxCredit(reportId) {
  const url = `${commonAggregateGstURL}/inputTaxCredit?reportReferenceId=${reportId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_INPUT_TAXCREDIT,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_INPUT_TAXCREDIT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateInputTaxCredit() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_INPUT_TAXCREDIT_EMPTY,
      payload: null
    });
  };
}

export function setInputTaxCreditPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_INPUT_TAXCREDIT_PERSIST,
      payload: data
    });
  };
}

export function getFilingStatus(gstId) {
  const url = `${commonGstURL}/filingStatus?gstId=${gstId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_FILINGSTATUS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_FILINGSTATUS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyFilingStatus() {
  return dispatch => {
    dispatch({
      type: GET_FILINGSTATUS_EMPTY,
      payload: null
    });
  };
}

export function setFilingStatusPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_FILINGSTATUS_PERSIST,
      payload: data
    });
  };
}

export function setSubtabsPersist(data) {
  return dispatch => {
    dispatch({
      type: SET_SUBTABS_PERSIST,
      payload: data
    });
  };
}

export function getSalesCustomerByMonth(gstId, month, aggregate) {
  const url = `${
    aggregate ? commonAggregateGstURL : commonGstURL
  }/salesCustomers?${
    aggregate ? `reportReferenceId=${gstId}` : `gstId=${gstId}`
  }&month=${month}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        if (response.data && response.data.length > 0) {
          const data = response.data.filter(ele => ele?.month === month);
          return dispatch({
            type: GET_SALES_CUSTOMER_BY_MONTH,
            payload: data?.[0]?.data ?? []
          });
        } else {
          return dispatch({
            type: GET_SALES_CUSTOMER_BY_MONTH,
            payload: []
          });
        }
      })
      .catch(error => {
        dispatch({
          type: GET_SALES_CUSTOMER_BY_MONTH_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptySalesCustomerByMonth() {
  return dispatch => {
    dispatch({
      type: GET_SALES_CUSTOMER_BY_MONTH_EMPTY,
      payload: null
    });
  };
}

export function getPurchasesSuppliersByMonth(gstId, month, aggregate) {
  const url = `${
    aggregate ? commonAggregateGstURL : commonGstURL
  }/purchasesSuppliers?${
    aggregate ? `reportReferenceId=${gstId}` : `gstId=${gstId}`
  }&month=${month}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        if (response.data && response.data.length > 0) {
          const data = response.data.filter(ele => ele?.month === month);
          return dispatch({
            type: GET_PURCHASES_SUPPLIERS_BY_MONTH,
            payload: data?.[0]?.data ?? []
          });
        } else {
          return dispatch({
            type: GET_PURCHASES_SUPPLIERS_BY_MONTH,
            payload: []
          });
        }
      })
      .catch(error => {
        dispatch({
          type: GET_PURCHASES_SUPPLIERS_BY_MONTH_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyPurchasesSuppliersByMonth() {
  return dispatch => {
    dispatch({
      type: GET_PURCHASES_SUPPLIERS_BY_MONTH_EMPTY,
      payload: null
    });
  };
}
